import { render, staticRenderFns } from "./EditDoctorPopup1.vue?vue&type=template&id=046be9b0"
import script from "./EditDoctorPopup1.vue?vue&type=script&lang=js"
export * from "./EditDoctorPopup1.vue?vue&type=script&lang=js"
import style0 from "./EditDoctorPopup1.vue?vue&type=style&index=0&id=046be9b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports